// extracted by mini-css-extract-plugin
export var buttonWrapper = "styles-module--buttonWrapper--fc7ce";
export var headerContent = "styles-module--headerContent--70c05";
export var headerWrapper = "styles-module--headerWrapper--6636c";
export var light = "styles-module--light--a1ec2";
export var wrapper = "styles-module--wrapper--a6e0a";